import { isEqual } from "./isequal";
import { isNil } from "./istype";

export function groupByIntoArrays<T, U>(
  arr: T[],
  pred: (t: T) => U,
  comp?: (u1: U, u2: U) => boolean,
): [U, T[]][] {
  if (arr.length === 0) {
    return [];
  }
  const compare = comp || isEqual;
  const groups: [U, T[]][] = [[pred(arr[0]), [arr[0]]]];
  for (const t of arr.slice(1)) {
    const currentTerm = pred(t);
    const matchingGrouping = groups.find((group) => {
      // No comp -> just equality -> don't need to check all members, just predicate
      if (isNil(comp)) {
        return compare(group[0], currentTerm);
      } else {
        // Custom comp -> check for all members
        // Eg: comparison = timerange overlap
        //                  -> Should group all timeranges that overlap, not just with first member
        return group[1].some((member) => compare(pred(member), currentTerm));
      }
    });
    if (matchingGrouping) {
      matchingGrouping[1].push(t);
    } else {
      groups.push([currentTerm, [t]]);
    }
  }
  return groups;
}
